var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 21C4.95 21 4.5 20.55 4.5 20V6C4.5 5.45 4.95 5 5.5 5H12C12.275 5 12.5 5.225 12.5 5.5V6.5C12.5 6.775 12.275 7 12 7H6.5V19H18.5V13.5C18.5 13.225 18.725 13 19 13H20C20.275 13 20.5 13.225 20.5 13.5V20C20.5 20.55 20.05 21 19.5 21H5.5Z",
    fill: "#836B55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0169 5H15.1867C14.9935 5 14.8148 5.11586 14.7423 5.29931C14.665 5.47794 14.7085 5.68552 14.8486 5.82553L16.5826 7.55865L11.7524 12.3863C11.564 12.5746 11.564 12.8787 11.7524 13.067L12.4334 13.7477C12.6218 13.936 12.9261 13.936 13.1193 13.7477L17.9496 8.92004L19.6788 10.6532C19.7658 10.7449 19.8914 10.7932 20.0169 10.7932C20.0797 10.7932 20.1425 10.7835 20.2005 10.7545C20.384 10.6821 20.5 10.5035 20.5 10.3104V5.48276C20.5 5.21724 20.2826 5 20.0169 5Z",
    fill: "#836B55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink2);
export default __webpack_public_path__ + "static/media/External_link_2.2511321e93c24026637f726ba65e6e68.svg";
export { ForwardRef as ReactComponent };